import { defaultState } from './defaultState'
import { actionTypes } from '../../../actions/src'
import { Types } from './types'

const nurtureAnalyticsReducer = (
  state: Types = { ...defaultState },
  { type, payload }
): Types => {
  switch (type) {
    case actionTypes.FETCH_NURTURE_ANALYTICS:
      return {
        ...state,
        loading: true,
        error: null
      }
    case actionTypes.FETCH_NURTURE_ANALYTICS_SUCCESSFUL:
      return {
        ...state,
        loading: false,
        error: null,
        data: payload.data,
        stats: payload.stats,
        uiState: payload.uiState,
        fetchedStartDate: payload.startDate,
        fetchedEndDate: payload.endDate
      }
    case actionTypes.FETCH_NURTURE_ANALYTICS_FAILED:
      return {
        ...state,
        loading: false,
        error: payload.error,
        data: [],
        stats: { ...defaultState.stats },
        uiState: payload.uiState || 'DISABLED',
        fetchedStartDate: payload.startDate ?? state.fetchedStartDate,
        fetchedEndDate: payload.endDate ?? state.fetchedEndDate
      }
    case actionTypes.DOWNLOAD_NURTURE_REPORT:
      return {
        ...state,
        downloadInProgress: true,
        downloadError: null
      }
    case actionTypes.DOWNLOAD_NURTURE_REPORT_SUCCESSFUL:
      return {
        ...state,
        downloadInProgress: false,
        downloadError: null
      }
    case actionTypes.DOWNLOAD_NURTURE_REPORT_FAILED:
      return {
        ...state,
        downloadInProgress: false,
        downloadError: payload?.error || 'Your nurture report could not be generated.'
      }
    default:
      return state
  }
}

export default nurtureAnalyticsReducer
